import React from 'react';
import { BaasicSelect, Loader, BaasicInput } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { isSome } from 'core/utils';

const TrackingTemplate = ({
	t,
	trackingViewStore: {
		loading,
		form,
		isSubmitted,
		onKeyPress,
		trackingStatus,
		carrierOptions,
		onCarrierSelect,
		selectedCarrier,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section className="ReactModal__form">
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{t('FULFILLMENTORDER.TRACKINGMODAL.TITLE')}</h3>
			</div>
			<div className="ReactModal__body">
				<BaasicSelect
					field={form.$('carrier')}
					clearable={false}
					options={carrierOptions}
					onChange={onCarrierSelect}
					value={selectedCarrier}
					className="spc--bottom--sml flex--grow--1"
				/>
				<BaasicInput field={form.$('trackingNumber')} onKeyUp={onKeyPress} />
				<div className="card card--sml spc--top--med">
					{isSubmitted ? (
						isSome(trackingStatus) && trackingStatus !== '' ? (
							<section>
								<div className="row">
									<div className="col col-sml-12 col-med-12 col-lrg-12">
										{t('FULFILLMENTORDER.TRACKINGMODAL.TRACKINGDATA.TRACKINGSTATUS')}
									</div>
								</div>
								<div className="row">
									<div className="col col-sml-12 col-med-12 col-lrg-12">
										<h5>{trackingStatus}</h5>
									</div>
								</div>
							</section>
						) : trackingStatus === '' || trackingStatus === null ? (
							<div className="row">
								<div className="col col-sml-12 col-med-12 col-lrg-12">
									<h5>{t('FULFILLMENTORDER.TRACKINGMODAL.TRACKINGSTATUSUNAVAILABLE')}</h5>
								</div>
							</div>
						) : null
					) : null}
				</div>
			</div>
		</section>
	);
};

export default defaultTemplate(TrackingTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/TrackingTemplate.jsx